export const formatZipCode = (value: string): string => {
    // Remove all non-numeric characters
    const numericOnly = value.replace(/\D/g, '');

    // Apply ZIP code mask: XXXXX or XXXXX-XXXX
    if (numericOnly.length <= 5) {
        return numericOnly;
    } else if (numericOnly.length <= 9) {
        return `${numericOnly.slice(0, 5)}-${numericOnly.slice(5)}`;
    } else {
        // Limit to 9 digits total
        return `${numericOnly.slice(0, 5)}-${numericOnly.slice(5, 9)}`;
    }
};
